// types
import {
  AppointmentExceptionResponse,
  CreateAppointmentRequest,
  DeleteAppointmentRequest,
  UpdateAppointmentRequest
} from 'generated/index';
import { DialogProps } from '../types';
import { AppointmentFormFieldData } from 'components/mrp/components/AppointmentForm/AppointmentForm.types';
import { Dispatch, SetStateAction } from 'react';

export enum SmartActionType {
  RECURRENCE_ACTION = 'RECURRENCE_ACTION',
  OVERLAP_ACTION = 'OVERLAP_ACTION'
}

export enum SmartActionState {
  NONE = 'NONE',
  ACTIVE = 'ACTIVE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

export type SmartAction = {
  type: SmartActionType;
  enabled?: boolean;
  interactionType?: 'informational' | 'interactive';
  state?: SmartActionState;
  props?: Record<string, any>;
};

export type PasteType = 'copy' | 'cut';

/** The verb the recurrence question uses; matches the keys in `mrp.dialogs.recurrence.actions`. */
export type RecurrenceActionType = 'update' | 'delete' | PasteType;

export type SmartActionComponentProps = {
  state?: SmartActionState;
  onSelect: <TProps extends { type: SmartActionType }>(props?: TProps) => void;
  setCanContinue: Dispatch<SetStateAction<boolean>>;
};

export type SmartActionDialogProps = DialogProps & {
  actionType?: 'update' | 'create' | 'delete';
  appointmentExceptions?: AppointmentExceptionResponse[];
  onExecuteAction?: <TResponse>(
    type: SmartActionType,
    props?: TResponse | any
  ) => void;
  onClose?: (props?: { ok: boolean }) => void;
  payload?: AppointmentFormFieldData;
  /** Set when the dialog follows a paste, so the recurrence question names the copy or cut instead of an update. */
  pasteType?: PasteType;
};

export type AppointmentPayload = CreateAppointmentRequest &
  UpdateAppointmentRequest &
  DeleteAppointmentRequest;
